import { type ReactNode } from "react";

import styles from "./SidebarSection.module.css";

/**
 * A group of related nav items.
 *
 * Replaces `SidebarGroup` from `@backstage/core-components`, but only keeps its
 * desktop behaviour. The original doubled as the mobile bottom-navigation item,
 * switching implementation on `isMobile` and requiring callers to pass
 * `to`/`icon` props that were meaningless on desktop. Mobile navigation is now
 * {@link MobileSidebar}'s concern, so this component is a plain group.
 *
 * The group is named for assistive technology but renders no visible heading,
 * matching the original. A heading would have to appear only when the rail is
 * expanded — there is no room for one at 72px — and anything that appears on
 * expand pushes every item below it downwards, so the item under the pointer
 * moves out from under it at the moment of hover. Dividers carry the grouping
 * visually instead, at a height that is identical in both states.
 */
export const SidebarSection = (props: {
    label: string;
    children: ReactNode;
}) => (
    <div className={styles.root} role="group" aria-label={props.label}>
        {props.children}
    </div>
);
